<template>
  <div>
    <header>
      <Header msg="Header" />
      <SettingsHeader msg="SettingsHeader" />
    </header>
    <main>
      <div class="userdata_edit container">
        <form @submit.prevent="submit">
          <div class="limit_num">
            <i>{{ name.length }}</i
            >/20
          </div>
          <div class="text_box">
            <input type="text" maxlength="20" v-model="name" />
            <button type="button">
              <i class="icon-delete" v-on:click="clear()"></i>
            </button>
          </div>
          <div class="error" v-if="!$v.name.required">請輸入訂購人顯示名稱</div>
          <button type="submit" :class="['save', $v.$invalid ? 'sent' : '']">
            儲存
          </button>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
// Guide:
// import './'  // 同一層目錄開始找
// import '../' // 上一層目錄開始找
// import '@/'  // src目錄下開始找
// import ''    // 直接打名稱則是node_modules

// @ is an alias to /src
import Header from "@/components/Header.vue";
import SettingsHeader from "@/components/SettingsHeader.vue";
import { Base64 } from "js-base64";
import apis from "@/services/apis";

import { required, minLength } from "vuelidate/lib/validators";

export default {
  name: "userData",
  data() {
    return {
      name: "",
      phone: "",
      picture: "",
      addresses: [],
    };
  },
  validations: {
    name: {
      required,
      minLength: minLength(2),
    },
  },
  components: {
    SettingsHeader,
    Header,
  },
  computed: {
    userId() {
      return localStorage.getItem("lineUserId");
    },
    uuid() {
      let uuid = localStorage.getItem("qcsso:uuid");
      let userProfile = localStorage.getItem("lineUserProfile");
      let self = this;

      return uuid;
      // return localStorage.getItem("lineUserId");
    },
    userProfile() {
      return JSON.parse(Base64.decode(localStorage.getItem("lineUserProfile")));
    },
  },
  methods: {
    getData() {
      let queryApi = apis.getUserData;
      let uid = this.userId;

      if (GLOBAL_ENV_SDKTYPE === "sso") {
        console.log('the uuid is ' + this.uuid);
        queryApi = apis.getSsoUserData;
        uid = this.uuid;
      }
      return queryApi(uid);
      // return fetch(
      //   `${process.env.VUE_APP_APIHOST}/apis/profile?user_id=${this.userId}`,
      //   {
      //     headers: {
      //       "Content-Type": "application/json",
      //     },
      //   }
      // )
      //   .then((res) => res.json())
      //   .catch((error) => console.error("Error:", error));
    },
    putData() {
      let putApi = apis.putUserData;
      let uid = this.userId;

      if (GLOBAL_ENV_SDKTYPE === "sso") {
        putApi = apis.putSsoUserData;
        uid = this.uuid;
      }
      return putApi(uid, { name: this.name });
    },
    clear() {
      this.name = "";
    },
    submit() {
      let self = this;
      console.log("submit!");
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.submitStatus = "ERROR";
        console.log("failed ");
      } else {
        // do your submit logic here
        this.submitStatus = "PENDING";

        self.putData().then((response) => {
          this.submitStatus = "OK";
          self.$router.push({
            path: self.$router.currentRoute.meta.backTo,
            query: self.$router.currentRoute.query,
          });
        });
        console.log("success");
      }
    },
  },
  mounted() {
    let self = this;
    console.log("cached data " + JSON.stringify(self.userProfile));
    this.getData().then((response) => {
      console.log("get response " + JSON.stringify(response));
      self.name = response.name || self.userProfile.name;
      self.picture = self.userProfile.picture || response.picture;
    });

    console.log(this.userProfile);
  },
};
</script>

<style scoped>
/* @import '../assets/css/theme_default.css'; */
</style>
